import { Link } from "react-router-dom";
import { openCookieSettings } from "./CookieBanner";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="text-xs font-semibold text-slate-500" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1.5">
      {items.map(([name, path], i) => (
        <li key={path} className="flex items-center gap-1.5">
          {i > 0 && <span aria-hidden>/</span>}
          {i < items.length - 1 ? <Link to={path} className="hover:text-slate-900 hover:underline">{name}</Link> : <span aria-current="page" className="text-slate-900">{name}</span>}
        </li>
      ))}
    </ol>
  </nav>
);

const LINKS = [["/shields", "Shields & prices"], ["/soccer", "Personalised football cards"], ["/gaa", "GAA shields"], ["/rugby", "Rugby shields"], ["/personalised-sports-gifts", "Sports gifts"], ["/club-fundraising-ideas", "Fundraising ideas"], ["/end-of-season-awards", "Awards ideas"], ["/guides", "Guides"], ["/design", "Design a shield"], ["/clubs", "Club sign-up"], ["/fundraising-games", "Fundraiser games"], ["/counties", "Counties & provinces"], ["/help", "How-to videos"], ["/coach", "Coach login"], ["/terms", "Terms of sale"], ["/privacy", "Privacy & cookies"]];

export const PublicFooter = () => (
  <footer className="border-t-2 border-slate-900 bg-slate-950 py-10 text-sm text-slate-400" data-testid="public-footer">
    <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-4 sm:px-6">
      <span>© {new Date().getFullYear()} sportsshields.ie · Personalised sports player shields, printed by <a href="https://www.businessprint.ie" target="_blank" rel="noopener" className="font-semibold underline hover:text-slate-900" data-testid="footer-businessprint-link">Business Print, Dublin</a></span>
      <nav aria-label="Footer" className="flex flex-wrap gap-4">
        {LINKS.map(([to, l]) => <Link key={to} to={to} className="hover:text-white hover:underline" data-testid={`footer-link-${to.slice(1)}`}>{l}</Link>)}
        <button type="button" onClick={openCookieSettings} className="hover:text-white hover:underline" data-testid="footer-cookie-settings">Cookie settings</button>
      </nav>
    </div>
  </footer>
);
